module.exports = __webpack_public_path__ + "img/hungary.86901d7a.png";